import { useRef } from 'react';
import OSCheck from '../utils/OSCheck';
import FKSWrap from './layout/wrap';
import MainPage from './pc/main';
import FKS_M_Wrap from './layout/mWrap';
import M_MainPage from './m/main';
import { useUser } from '../hooks/user/useUser';
import { useWindowResize } from '../hooks/window/useWindowResize';

const MainIndex = () => {
  const currentOS = OSCheck();
  const { isMobile } = useWindowResize();

  const sectionRefs = {
    section1: useRef<HTMLDivElement>(null),
    section2: useRef<HTMLDivElement>(null),
    section3: useRef<HTMLDivElement>(null),
    section4: useRef<HTMLDivElement>(null),
    sectionCI: useRef<HTMLDivElement>(null),
  };

  const scrollToSection = (section: string) => {
    const sectionTop = (sectionRefs as any)[
      section
    ]?.current?.getBoundingClientRect().top;

    if (sectionTop !== undefined) {
      const scrollPosition = window.scrollY + sectionTop - 50;
      window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    }
  };

  const { data: userData, isLoading } = useUser();
  const isLogin = !!userData;

  if (isLoading) {
    return null;
  }

  return (
    <>
      {/* {currentOS === 'Android' || currentOS === 'iOS' ? (
        <FKS_M_Wrap>
          <M_MainPage
            sectionRefs={sectionRefs}
            scrollToSection={scrollToSection}
          />
        </FKS_M_Wrap>
      ) :  */}
      {isMobile ? (
        <FKS_M_Wrap isLogin={isLogin}>
          <M_MainPage
            sectionRefs={sectionRefs}
            scrollToSection={scrollToSection}
          />
        </FKS_M_Wrap>
      ) : (
        <FKSWrap isLogin={isLogin} scrollToSection={scrollToSection}>
          <MainPage
            sectionRefs={sectionRefs}
            scrollToSection={scrollToSection}
          />
        </FKSWrap>
      )}
    </>
  );
};

export default MainIndex;
